import { Logger } from "./Logger";
import { gatherVideoClientDataSource } from "./Globals";
import { simpleTypeCheck } from "./simpleTypeCheck";
import { generatePlaceholder } from "./generatePlaceholder";
export function LoggableMethodFactory(file) {
    return function (_target, memberName, propertyDescriptor) {
        const originalMethod = propertyDescriptor.value;
        propertyDescriptor.value = function (...args) {
            try {
                const filteredArgs = args.map((a) => (simpleTypeCheck(a) ? a : generatePlaceholder(a)));
                Logger.debug(`ENTER [${file}][${memberName}]`, filteredArgs);
            }
            catch {
                Logger.debug(`ENTER [${file}][${memberName}]`);
            }
            const now = gatherVideoClientDataSource.performance().now();
            const result = originalMethod.apply(this, args);
            const exitLog = () => Logger.debug(`EXIT [${file}][${memberName}] ${(gatherVideoClientDataSource.performance().now() - now).toFixed(2)}ms`, simpleTypeCheck(result) ? result : generatePlaceholder(result));
            if (typeof result === "object" && typeof result.then === "function") {
                const promise = result.then(exitLog);
                if (typeof promise.catch === "function") {
                    promise.catch((e) => e);
                }
            }
            else {
                exitLog();
            }
            return result;
        };
    };
}
export function LoggableClass(ignore) {
    return (target) => {
        for (const propertyName of Object.getOwnPropertyNames(target.prototype)) {
            const descriptor = Object.getOwnPropertyDescriptor(target.prototype, propertyName);
            if (!descriptor) {
                continue;
            }
            const originalMethod = descriptor.value;
            if (!(originalMethod instanceof Function) || ignore?.includes(propertyName)) {
                continue;
            }
            descriptor.value = function (...args) {
                try {
                    const filteredArgs = args.map((a) => (simpleTypeCheck(a) ? a : generatePlaceholder(a)));
                    Logger.debug(`ENTER [${target.name}][${propertyName}]`, filteredArgs);
                }
                catch {
                    Logger.debug(`ENTER [${target.name}][${propertyName}]`);
                }
                const now = gatherVideoClientDataSource.performance().now();
                const result = originalMethod.apply(this, args);
                const exitLog = () => {
                    Logger.debug(`EXIT [${target.name}][${propertyName}] ${(gatherVideoClientDataSource.performance().now() - now).toFixed(2)}ms`, simpleTypeCheck(result) ? result : generatePlaceholder(result));
                };
                if (typeof result === "object" && typeof result.then === "function") {
                    const promise = result.then(exitLog);
                    if (typeof promise.catch === "function") {
                        promise.catch((e) => e);
                    }
                }
                else {
                    exitLog();
                }
                return result;
            };
            Object.defineProperty(target.prototype, propertyName, descriptor);
        }
    };
}
//# sourceMappingURL=log.decorator.js.map